export default function (){return [
    {icon: 'fa-address-book', text: 'Overview', to: '/overview'},
    {icon: 'fa-bolt', text: 'Energy', to: '/hkl-energy'},
    {icon: 'fa-chart-bar', text: 'KPI', to: '/hkl-kpi'},
    {icon: 'fa-bell', text: 'Notification Breakdown', to: '/notification-breakdown'},
    {icon: 'fa-calendar-alt', text: 'Monthly Summary', to: '/monthly-summary'},
    {icon: 'fa-piggy-bank', text: 'Optimization Saving', to: '/optimizationsaving',facilityFilter:"ES"},
    {icon: 'fa-network-wired', text: 'Facility Overview', href: 'https://hkl-cmc.jec-digital.com'},
    {
        icon: 'fa-angle-up',
        'icon-alt': 'fa-angle-down',
        text: 'Plots',
        model: false,
        children: [
            {icon: 'fa-chart-line', text: 'Time Series Plots', to: '/multiplots'},
            {icon: 'fa-chart-line', text: 'Equipment Plots', to: '/equipment-plots'},
            {icon: 'fa-layer-group', text: 'Facet Plots', to: '/plot/facet'},
            {icon: 'fa-chart-bar', text: 'Scatter Plots', to: '/sensors'}
        ]
    },
    {icon: 'fa-bell', text: 'Fault Detection', to: '/fault'},
    {icon: 'fa-bell', text: 'Fault Detection (Machine Learning)', to: '/modelsummary'},
    {
        icon: 'fa-angle-up',
        'icon-alt': 'fa-angle-down',
        text: 'Diagnostics',
        model: false,
        children: [
            { text: 'Cooling Load', to: '/load'},
            {
                "text": "Cooling Load VS Outdoor Temperature",
                "to": "/cl-vs-oat"
            },
            {
                "text": "Chiller Sequencing Profile - % of FLA",
                "to": "/chiller-sequencing-fla",
                facilityExceptFilter:"JH"
            },
            {
                text: 'Chiller Sequencing Profile - DTchw',
                to: '/chiller-sequencing-delta',
                facilityFilter:"ES"
            }
        ]
    },
    {
        icon: 'fa-angle-up',
        'icon-alt': 'fa-angle-down',
        text: 'Control Logic',
        model: false,
        children: [
            {icon: 'fa-bolt', text: 'Energy Efficiency', to: '/energyefficiency'},
        ]
    },
    {
        icon: 'fa-angle-up',
        'icon-alt': 'fa-angle-down',
        text: 'Config',
        model: false,
        children: [
            {icon: 'fa-tools', text: 'Equipments', to: '/equipments'},
            {icon: 'fa-building', text: 'Facilities', to: '/facility'},
            {icon: 'fa-bell', text: 'Anomaly Descriptions', to: '/anomaly-description'},
            {icon: 'fa-broadcast-tower', text: 'Points', to: '/points'},
            {icon: 'fa-cog', text: 'Config', to: '/config'},
            {icon: 'fa-ruler-horizontal', text: 'Parameter', to: '/parameter'},
            {icon: 'fa-chart-line', text: 'KPI', to: '/KPI'},
            {icon: 'fa-sliders-h', text: 'Settings', to: '/settings'},
            {icon: 'fa-mail-bulk', text: 'Report', to: '/report'},
            {icon: 'fa-align-justify', text: 'Rules', to: '/rules'},
            {icon: 'fa-download', text: 'Export Data', to: '/viewdata'}
        ]
    },
    {icon: 'fa-notes-medical', text: 'Maintenance Record', to: '/maintenancerecord'},
    {icon: 'fa-question', text: 'Help', to: '/help'}
]}
